export default __webpack_public_path__ + "static/media/flag-cayman-islands.4cf12286.svg";